import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 1,
  class: "empty"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "bottom"
}

import { defineAsyncComponent, reactive, onMounted, } from 'vue'
import { useRouter } from "vue-router"
import { appMerchent } from "@/utils/api"
import { getParam, safeRouter } from '@/utils/util'
import { toast } from '@/components/toast'
import AdView from '@/components/ad.vue'
interface HomeState {
    height: number;
    nickname: string;
    mobile: string;
    showRule: boolean;
    loading: boolean;
    showAd: boolean;
    id: number;
    lid: number;
    items: AppTinyItem[];
    adname: string;
    link: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const Loading = defineAsyncComponent(() => import('@/components/loading.vue'))
const state = reactive<HomeState>({
    height: 400,
    nickname: '',
    mobile: '',
    showRule: false,
    loading: true,
    showAd: false,
    items: [],
    id: 0,
    lid: 0,
    adname: '',
    link: ''
})
const router = useRouter()

onMounted(() => {
    const height = document.body.clientHeight
    state.height = height
    const param = getParam()
    state.id = param.id
    state.lid = param.lid
    fetchMyInfo()
})


const fetchMyInfo = async () => {
    const rsp = await appMerchent(state.lid, state.id)
    state.loading = false
    if (rsp.result == 0) {
        const title = document.querySelector('title')
        if (title) {
            title.innerText = rsp.data.name
        }
        // 不存在的商户
        if (rsp.data.result == 404 && rsp.data.link) {
            // 1.5 分钟后跳转
            setTimeout(() => {
                // 重定向到目标地址
                window.location.href = rsp.data.link
            }, 1500)
            return
        }
        if (rsp.data.items.length == 1) {
            clickItem(rsp.data.items[0])
            return
        }
        const autoClick = rsp.data.items.find(item => item.direct)
        if (autoClick) {
            clickItem(autoClick)
            return
        }

        state.items = rsp.data.items
        if (state.items.length > 0) {
            state.id = rsp.data.id
            state.lid = rsp.data.lid
        } else {
            state.id = rsp.data.id
            state.lid = rsp.data.lid
            console.log(rsp.data.link)
            if (rsp.data.link) {
                // 重定向到目标地址
                window.location.href = rsp.data.link
            }
        }
        state.link = rsp.data.link
        state.showAd = rsp.data.show_ad

    } else {
        toast(rsp.message)
    }
}
const clickItem = (item: AppTinyItem) => {
    const param = {
        id: state.id,
        lid: state.lid,
    }
    safeRouter(router, 'start', { ...param, id: item.id })
}

const clickQuery = () => {
    const param = {
        id: state.id,
        lid: state.lid,
    }
    safeRouter(router, 'query', { ...param })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "page",
    style: _normalizeStyle({ height: state.height + 'px' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: idx,
          onClick: ($event: any) => (clickItem(item))
        }, [
          _createElementVNode("img", {
            class: "cover",
            src: item.cover,
            alt: "封面图"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.display || item.name), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "space" }, null, -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "btn" }, "立即领卡", -1))
          ])
        ], 8, _hoisted_2))
      }), 128)),
      (state.showAd)
        ? (_openBlock(), _createBlock(AdView, {
            key: 0,
            class: "ad-view",
            position: "首页"
          }))
        : _createCommentVNode("", true),
      (state.loading == false && state.items.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (state.id <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "没有对应的供应商"))
              : _createCommentVNode("", true),
            (state.id > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "您查看的商户暂无可用应用"))
              : _createCommentVNode("", true),
            (state.id > 0 && state.link)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  class: "link",
                  href: state.link
                }, "查看其他商户的联通卡", 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (state.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "btn",
            onClick: clickQuery
          }, "查询订单")
        ]))
      : _createCommentVNode("", true),
    (state.loading)
      ? (_openBlock(), _createBlock(_unref(Loading), { key: 1 }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})